import "./jquery-global";
import $ from "jquery";

// carico i moduli legacy e i plugin jQuery
import "@popperjs/core";
import "bootstrap";
import "pure";
require("@knighttower/block-ui");
import "~/components/RecaptchaBadgeHider";
import Swiper from "swiper";
import {
    Thumbs,
    FreeMode,
    Virtual,
    Keyboard,
    Mousewheel,
    Navigation,
    Pagination,
    Scrollbar,
    Parallax,
    Zoom,
    Controller,
    A11y, 
    History,
    HashNavigation,
    Autoplay,
    Grid, 
    Manipulation,
    EffectFade,
    EffectCube,
    EffectFlip,
    EffectCoverflow,
    EffectCreative,
    EffectCards
} from "swiper/modules";
// Swiper Class
const modules = [Thumbs, FreeMode, Virtual, Keyboard, Mousewheel, Navigation, Pagination, Scrollbar, Parallax, Zoom, Controller, A11y, History, HashNavigation, Autoplay, Grid, Manipulation, EffectFade, EffectCube, EffectFlip, EffectCoverflow, EffectCreative, EffectCards];
Swiper.use(modules);

import bootbox from "bootbox";

import ui from "./ui";
import * as auth from "./auth";
import Page from "~/pages/Page";
import { initBackToTop } from "~/utils/backToTop";
import { initArrows } from "~/utils/arrows";
import { initScrollAnimation } from "~/utils/scrollAnimation";

$(document).ready(() => {
    initBackToTop();
    initArrows();
    initScrollAnimation();
});
 

declare global {
    interface Window {
        IsDebug: boolean;
        UseCookieCredentials: boolean;
        WsAuthClientCode: string;
        BaseUrlAnagrafica: string;
        BaseUrlWeb: string;
        BaseUrlWebApi: string;
        ATP_ListID_Newsletter: string;
        ATP_GroupId_Newsletter: string;
        ATP_GroupId_Registrazione: string;
        ATP_GroupId_FormContatto: string;
        MailVendite: string;
        Telefono: string;
        RecaptchaKEY: string;
        $: JQueryStatic;
        jQuery: JQueryStatic;
        bootbox: BootboxStatic;
        ATP: ATPApplication;
        bsCustomFileInput: any;
        Swiper: typeof Swiper;
        ThisPage: Page;
        App: ATPApplication;
        CodeTracing: number;
        FACEBOOK_APPID: string;
        FB: facebook.FacebookStatic; // Facebook SDK
        fbAsyncInit: () => void; // Facebook SDK init callback
        AOS: {
            init: (options?: object) => void;
            refresh: () => void;
            refreshHard: () => void;
        };
    }
   
    interface JQueryStatic {
        ajaxWithCredentials(settings: JQuery.AjaxSettings): JQuery.jqXHR;
    }
    
    interface HTMLFormElement {
        /**
         * Rimuove la classe is-valid dai campi vuoti non obbligatori
         * per evitare che vengano mostrate spunte verdi su campi non compilati
         */
        removeValidFromEmptyOptionalFields(): void;
    }
    
    interface Element {
        addOrReplaceEventListener(type: string, listener: EventListenerOrEventListenerObject, options?: boolean | AddEventListenerOptions): void;
    }
    interface Document {
        addOrReplaceEventListener(type: string, listener: EventListenerOrEventListenerObject, options?: boolean | AddEventListenerOptions): void;
    }
}
declare var BaseUrlWeb: string;
declare var bsCustomFileInput: any;

interface ATPApplication {
    Page: Page;
    UI: typeof ui;
    Auth: typeof auth;
}
 
export const App: ATPApplication = {
    get Page() {
        return Page.current;
    },
    UI: ui,
    Auth: auth
}

export const domSelectors = {
    SignInModal: "#ModalLoginPopup",
    PrivacyModal: "#modal-privacy",
    PrivacyModalAcceptButton: "#btnApprovaPrivacy",
    PrivacyModalCancelButton: "#btnAnnullaPrivacy",
    PrivacyModalTemplate: "#TemplateModalePrivacy",
    RegisterForm: "#form-register",
    // RegisterSignInButton: "#showModalLogin",
    RegisterMessageText: "div.messageText2",
    LoggedUserBox: "#loggedarea",
    PageError: "",
    UserMenuButton: ".newUserMenu__toggle",
    UserMenu: ".newUserMenu__menu",
    UserMenuExpander: ".dropRes__btn",
    UserMenuNavigatePost: ".menu-navigate-post",
    Spinner: "#loading2",
    CaptchaValidation: "#ggtoken",
    GoogleSiteKey: "#GoogleSiteKey",
    ProfiloDatiPersonaliTab: "#datipersonali-tab",
    ProfiloDocumentiTab: "#documenti-tab",
    ProfiloPasswordTab: "#password-tab",
    ProfiloConsensiTab: "#privacy-tab"
}

export const routes = {
    Logout: "/Account/Logout",
    Home: "/Home/Index",
    Error: "/Error/Error"
}

/////////////////////// impostazioni globali di jQuery ///////////////////////

// $.ajaxSetup({
//     xhrFields: {
//         withCredentials: true // per inviare i cookie di autenticazione con le richieste AJAX
//     },
//     crossDomain: true
// });

/**
 * Metodo helper per chiamate AJAX con credenziali
 * Estende jQuery con $.ajaxWithCredentials per gestire automaticamente withCredentials e crossDomain
 */
$.ajaxWithCredentials = function(settings: JQuery.AjaxSettings): JQuery.jqXHR {
    const defaultSettings: JQuery.AjaxSettings = {
        xhrFields: {
            withCredentials: true
        },
        crossDomain: true
    };
    
    // Merge delle impostazioni: defaultSettings vengono sovrascritti da settings
    const mergedSettings = $.extend(true, {}, defaultSettings, settings);
    
    return $.ajax(mergedSettings);
};

window.bootbox = bootbox;
window.Swiper = Swiper; // esporto Swiper globalmente per i moduli legacy caricati in HTML
window.App = App;
window.App.Auth = auth;
window.App.UI = ui;

/////////////////////// HTMLFormElement Extensions ///////////////////////

/**
 * Rimuove la classe is-valid dai campi vuoti non obbligatori
 * per evitare che vengano mostrate spunte verdi su campi non compilati
 */
HTMLFormElement.prototype.removeValidFromEmptyOptionalFields = function(): void {
    // Seleziona tutti i campi input, select e textarea del form
    const fields = this.querySelectorAll('input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), select, textarea');
    
    fields.forEach((field: Element) => {
        const inputField = field as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
        
        // Salta i campi disabled
        if (inputField.disabled) {
            return;
        }
        
        const value = $(inputField).val();
        const isEmpty = !value || (typeof value === 'string' && value.trim() === '') || 
                       (Array.isArray(value) && value.length === 0);
        const isRequired = inputField.hasAttribute('required');
        
        // Se il campo è vuoto e non è obbligatorio
        if (isEmpty && !isRequired) {
            // Rimuovi is-valid e imposta custom validity per forzare lo stato neutro
            $(inputField).removeClass('is-valid').addClass('is-valid-empty');
        } else {
            // Rimuovi la classe custom se il campo è valorizzato
            $(inputField).removeClass('is-valid-empty');
        }
    });
};

Element.prototype.addOrReplaceEventListener = function( type: string, listener: EventListenerOrEventListenerObject, options?: boolean | AddEventListenerOptions): void {
    // Rimuove eventuali listener esistenti dello stesso tipo
    this.removeEventListener(type, listener as EventListenerOrEventListenerObject, options);
    // Aggiunge il nuovo listener
    this.addEventListener(type, listener as EventListenerOrEventListenerObject, options);
}
Document.prototype.addOrReplaceEventListener = function( type: string, listener: EventListenerOrEventListenerObject, options?: boolean | AddEventListenerOptions): void {
    // Rimuove eventuali listener esistenti dello stesso tipo
    this.removeEventListener(type, listener as EventListenerOrEventListenerObject, options);
    // Aggiunge il nuovo listener
    this.addEventListener(type, listener as EventListenerOrEventListenerObject, options);
}
